import { render, staticRenderFns } from "./PixabayInfoText.vue?vue&type=template&id=f5606a6a&scoped=true"
import script from "./PixabayInfoText.vue?vue&type=script&lang=js"
export * from "./PixabayInfoText.vue?vue&type=script&lang=js"
import style0 from "./PixabayInfoText.vue?vue&type=style&index=0&id=f5606a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5606a6a",
  null
  
)

export default component.exports